module.exports = __webpack_public_path__ + "img/icon-word.af250e19.png";